// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3MvgT","title":"InfoRow_title__2beHs"};